/**
 * Add no further imports here: `ChannelPage` reads this fragment at module scope
 * from inside an import cycle. Guarded by `pages/Channel/fragmentInitOrder.test.ts`.
 */
import { graphql } from '~publish/graphql'

export const QueueList_Channel = graphql(/* GraphQL */ `
  fragment QueueList_Channel on Channel {
    id
    name
    service
    allowedActions
    isQueuePaused
    timezone
    postingSchedule {
      day
      times
      paused
    }
    postingGoal {
      goal
    }
  }
`)
